import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const navDefaultVariants = {
  "variant": "minimal",
  "size": "md"
}
const navCompoundVariants = []

const navSlotNames = [
  [
    "root",
    "Nav__root"
  ],
  [
    "item",
    "Nav__item"
  ],
  [
    "link",
    "Nav__link"
  ]
]
const navSlotFns = /* @__PURE__ */ navSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, navDefaultVariants, getSlotCompoundVariant(navCompoundVariants, slotName))])

const navFn = memo((props = {}) => {
  return Object.fromEntries(navSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const navVariantKeys = [
  "variant",
  "size",
  "isVertical"
]
const getVariantProps = (variants) => ({ ...navDefaultVariants, ...compact(variants) })

export const nav = /* @__PURE__ */ Object.assign(navFn, {
  __recipe__: false,
  __name__: 'nav',
  raw: (props) => props,
  variantKeys: navVariantKeys,
  variantMap: {
  "variant": [
    "default",
    "tab",
    "pill",
    "minimal"
  ],
  "size": [
    "sm",
    "md",
    "lg"
  ],
  "isVertical": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, navVariantKeys)
  },
  getVariantProps
})